
import React from "react";

const About = () => {
  return (
    <div id="about" className="about" style={{ paddingTop: "10px", margin: "20px" }}>
      <div className="inside-about">
        <div className="about-centered">
          <div>
            <div className="buttonnn wow animate__animated animate__fadeIn">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <circle cx="6.06896" cy="5.9508" r="5.484" fill="#EEFF30" />
              </svg> Our Goal
            </div>
          </div>
          <div className="GoalClass" style={{ marginTop: "30px" }}>
            Your CEO's <span className="yellow">right hand</span> <br /> Your CFO's{" "}
            <span className="yellow">left hand</span>
          </div>
        </div>
        <div className="button"></div>
      </div>

      <div className="row" style={{ paddingBottom: "15px" }}>
        {/* First Column */}
        <div className="column">
          <div className="section-01">
            <div className="image-section wow animate__animated animate__fadeIn">
              <img src="/img/dirt.png" alt="Dirt Work" />
            </div>
            <div className="text-section">
              <div className="big-title wow animate__animated animate__fadeIn">
                <div className="big-title2">We do the dirty <br /> work with you.</div>
              </div>
              <div className="text-little">
                <div className="text-little2 wow animate__animated animate__fadeIn">
                  We deep dive into the details, tackling the challenges at their core.
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Second Column */}
        <div className="column">
          <div className="section-01">
            <div className="image-section wow animate__animated animate__fadeIn">
              <img src="/img/present.png" alt="Moving Forward" />
            </div>
            <div className="text-section wow animate__animated animate__fadeIn">
              <div className="big-title wow animate__animated animate__fadeIn">
                <div className="big-title2">Moving forward, <br /> achieving milestones.</div>
              </div>
              <div className="text-little">
                <div className="text-little2 wow animate__animated animate__fadeIn">
                  Action is the key. We plan and execute to get to the point on time.
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Third Column */}
        <div className="column">
          <div className="section-01">
            <div className="image-section wow animate__animated animate__fadeIn">
              <img src="/img/la3.png" alt="Order" />
            </div>
            <div className="text-section wow animate__animated animate__fadeIn">
              <div className="big-title wow animate__animated animate__fadeIn">
                <div className="big-title2">Order. <br />Order. Order.</div>
              </div>
              <div className="text-little">
                <div className="text-little2 wow animate__animated animate__fadeIn">
                  Your assets are there, we just want you to maximize benefit out of them.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
